import { gql } from "@apollo/client";

const ResetPasswordMutation = gql`
  mutation newPassword($userId: UUID!, $password: String!) {
    changePassword(input: { tuserId: $userId, tpassword: $password }) {
      boolean
    }
  }
`;

const hash = "d4404057a547c432f2f6c4fd9e89bb294b8bde99c481c163cea4133e80f30123";

export { ResetPasswordMutation, hash };
